import "./index.css";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
	return (
		<main style={{ padding: "72px 0 56px", minHeight: "80vh" }}>
			<div className="container" style={{ maxWidth: "800px" }}>
				<h1
					style={{ fontSize: "36px", marginBottom: "12px", color: "#14213D" }}
				>
					Privacy Policy
				</h1>
				<p
					style={{
						marginBottom: "32px",
						lineHeight: "1.6",
						color: "#64748B",
						fontSize: "15px",
					}}
				>
					Last updated: 7 August 2026
				</p>

				<p
					style={{ marginBottom: "32px", lineHeight: "1.6", color: "#475569" }}
				>
					This Privacy Policy explains how Oxide Digital Technology ("we", "us",
					"our") collects, uses and protects your information across the Posa
					platform, which includes the Posa Sport app (for discovering and
					joining activities, events, venues and trainers) and the Posa Studio
					app (for venues, studios and trainers managing their business),
					together with this website. By using either app or this website, you
					agree to the practices described below. These practices apply together
					with our{" "}
					<Link
						to="/terms-and-conditions"
						style={{ color: "#007AFF", textDecoration: "underline" }}
					>
						Terms and Conditions
					</Link>
					.
				</p>

				<section style={{ marginBottom: "48px" }}>
					<h2
						style={{
							fontSize: "24px",
							marginBottom: "16px",
							color: "#14213D",
							marginTop: "32px",
						}}
					>
						Information We Collect
					</h2>

					<h3
						style={{
							fontSize: "20px",
							marginTop: "24px",
							marginBottom: "12px",
							color: "#14213D",
						}}
					>
						Account & Profile Information
					</h3>
					<p
						style={{
							marginBottom: "16px",
							lineHeight: "1.6",
							color: "#475569",
						}}
					>
						We use Firebase Authentication to enable secure sign-in with your
						email address, phone number, Google account, or Apple ID.
					</p>
					<ul
						style={{
							marginBottom: "24px",
							paddingLeft: "24px",
							lineHeight: "1.8",
							color: "#475569",
						}}
					>
						<li>User ID (UID)</li>
						<li>Email address or phone number (if used for login)</li>
						<li>Display name (optional)</li>
						<li>Profile photo (optional)</li>
					</ul>

					<h3
						style={{
							fontSize: "20px",
							marginTop: "24px",
							marginBottom: "12px",
							color: "#14213D",
						}}
					>
						Activity & Booking Data
					</h3>
					<ul
						style={{
							marginBottom: "24px",
							paddingLeft: "24px",
							lineHeight: "1.8",
							color: "#475569",
						}}
					>
						<li>Activities and events you create, join or host</li>
						<li>Venue and trainer bookings, including approval status</li>
						<li>Participation history</li>
						<li>
							Messages sent in chat with other participants of a joined session
						</li>
					</ul>

					<h3
						style={{
							fontSize: "20px",
							marginTop: "24px",
							marginBottom: "12px",
							color: "#14213D",
						}}
					>
						Location Data
					</h3>
					<p
						style={{
							marginBottom: "24px",
							lineHeight: "1.6",
							color: "#475569",
						}}
					>
						Posa Sport uses your approximate or precise location, where
						permitted, to show nearby activities, events and venues on the
						Explore and Map tabs.
					</p>

					<h3
						style={{
							fontSize: "20px",
							marginTop: "24px",
							marginBottom: "12px",
							color: "#14213D",
						}}
					>
						Payment & Payout Information
					</h3>
					<p
						style={{
							marginBottom: "24px",
							lineHeight: "1.6",
							color: "#475569",
						}}
					>
						Most bookings are paid on-site and are not processed by us. Venue
						owners and trainers using Posa Studio may provide bank account
						details for payouts, which are handled securely through our payment
						partner, Paystack.
					</p>

					<h3
						style={{
							fontSize: "20px",
							marginTop: "24px",
							marginBottom: "12px",
							color: "#14213D",
						}}
					>
						Device & Notification Data
					</h3>
					<p
						style={{
							marginBottom: "24px",
							lineHeight: "1.6",
							color: "#475569",
						}}
					>
						We collect push notification tokens and basic device/browser
						information so that joins, messages, booking approvals and schedule
						changes can reach you.
					</p>
				</section>

				<section style={{ marginBottom: "48px" }}>
					<h2
						style={{
							fontSize: "24px",
							marginBottom: "16px",
							color: "#14213D",
							marginTop: "32px",
						}}
					>
						How We Use Your Information
					</h2>
					<ul
						style={{
							marginBottom: "24px",
							paddingLeft: "24px",
							lineHeight: "1.8",
							color: "#475569",
						}}
					>
						<li>
							To authenticate and identify users securely across Posa Sport and
							Posa Studio
						</li>
						<li>To manage user sessions</li>
						<li>
							To personalize your experience, such as showing your profile
							picture or name
						</li>
						<li>
							To match players with nearby activities, events, venues and
							trainers
						</li>
						<li>
							To process and sync booking requests and approvals between Posa
							Sport and Posa Studio
						</li>
						<li>To enable chat between participants of a joined session</li>
						<li>
							To send notifications about joins, messages, bookings and schedule
							changes
						</li>
						<li>To pay out venue owners and trainers via Paystack</li>
					</ul>
				</section>

				<section style={{ marginBottom: "48px" }}>
					<h2
						style={{
							fontSize: "24px",
							marginBottom: "16px",
							color: "#14213D",
							marginTop: "32px",
						}}
					>
						Data Sharing
					</h2>
					<p
						style={{
							marginBottom: "16px",
							lineHeight: "1.6",
							color: "#475569",
						}}
					>
						We do not sell your data or use it for advertising. We only share
						information as needed to run the Posa platform:
					</p>
					<ul
						style={{
							marginBottom: "24px",
							paddingLeft: "24px",
							lineHeight: "1.8",
							color: "#475569",
						}}
					>
						<li>
							With Firebase (Google LLC), which securely stores authentication,
							activity and chat data
						</li>
						<li>
							With Paystack, to process payouts for venue owners and trainers on
							Posa Studio
						</li>
						<li>
							With other users, limited to what a session or booking requires —
							for example, your name and photo are visible to participants of an
							activity you join, and a host sees the profile of someone
							requesting a booking
						</li>
					</ul>
				</section>

				<section style={{ marginBottom: "48px" }}>
					<h2
						style={{
							fontSize: "24px",
							marginBottom: "16px",
							color: "#14213D",
							marginTop: "32px",
						}}
					>
						Data Retention
					</h2>
					<p
						style={{
							marginBottom: "24px",
							lineHeight: "1.6",
							color: "#475569",
						}}
					>
						Your data is retained as long as your account is active. You may
						request account deletion at any time from within the app, which will
						remove your related information.
					</p>
				</section>

				<section style={{ marginBottom: "48px" }}>
					<h2
						style={{
							fontSize: "24px",
							marginBottom: "16px",
							color: "#14213D",
							marginTop: "32px",
						}}
					>
						Your Choices
					</h2>
					<ul
						style={{
							marginBottom: "24px",
							paddingLeft: "24px",
							lineHeight: "1.8",
							color: "#475569",
						}}
					>
						<li>Edit your profile name, photo and language at any time</li>
						<li>Manage notification preferences in your app settings</li>
						<li>Request access to, correction of, or deletion of your data</li>
					</ul>
				</section>

				<section style={{ marginBottom: "48px" }}>
					<h2
						style={{
							fontSize: "24px",
							marginBottom: "16px",
							color: "#14213D",
							marginTop: "32px",
						}}
					>
						Our Providers
					</h2>
					<p
						style={{
							marginBottom: "24px",
							lineHeight: "1.6",
							color: "#475569",
						}}
					>
						Authentication, data storage and chat are powered by{" "}
						<a
							href="https://firebase.google.com/support/privacy"
							target="_blank"
							rel="noopener noreferrer"
							style={{ color: "#007AFF", textDecoration: "underline" }}
						>
							Firebase, a service of Google LLC
						</a>
						. Payouts for venue owners and trainers are processed by{" "}
						<a
							href="https://paystack.com/privacy"
							target="_blank"
							rel="noopener noreferrer"
							style={{ color: "#007AFF", textDecoration: "underline" }}
						>
							Paystack
						</a>
						.
					</p>
				</section>

				<section style={{ marginBottom: "48px" }}>
					<h2
						style={{
							fontSize: "24px",
							marginBottom: "16px",
							color: "#14213D",
							marginTop: "32px",
						}}
					>
						Changes to This Policy
					</h2>
					<p
						style={{
							marginBottom: "24px",
							lineHeight: "1.6",
							color: "#475569",
						}}
					>
						We may update this Privacy Policy from time to time. When we do, we
						will revise the “Last updated” date on this page.
					</p>
				</section>

				<section style={{ marginBottom: "48px" }}>
					<h2
						style={{
							fontSize: "24px",
							marginBottom: "16px",
							color: "#14213D",
							marginTop: "32px",
						}}
					>
						Contact Us
					</h2>
					<p
						style={{
							marginBottom: "24px",
							lineHeight: "1.6",
							color: "#475569",
						}}
					>
						If you have questions about this Privacy Policy or your data,
						contact Oxide Digital Technology at{" "}
						<a
							href="mailto:support@oxide-digital.com"
							style={{ color: "#007AFF", textDecoration: "underline" }}
						>
							support@oxide-digital.com
						</a>
						, or visit{" "}
						<a
							href="https://www.oxide-digital.com/"
							target="_blank"
							rel="noopener noreferrer"
							style={{ color: "#007AFF", textDecoration: "underline" }}
						>
							oxide-digital.com
						</a>
						.
					</p>
				</section>

				<div
					style={{
						marginTop: "48px",
						paddingTop: "24px",
						borderTop: "1px solid #e5e7eb",
						lineHeight: "1.6",
						color: "#475569",
					}}
				>
					<p style={{ margin: 0 }}>
						The Posa platform is developed and maintained by Oxide Digital
						Technology. Copyright in Posa Sport, Posa Studio and this website
						belongs to{" "}
						<a
							href="https://www.oxide-digital.com/"
							target="_blank"
							rel="noopener noreferrer"
							style={{ color: "#007AFF", textDecoration: "underline" }}
						>
							Oxide Digital Technology
						</a>
						.
					</p>
				</div>

				<div
					style={{
						marginTop: "32px",
						paddingTop: "24px",
						borderTop: "1px solid #e5e7eb",
					}}
				>
					<Link
						to="/"
						style={{
							color: "#007AFF",
							textDecoration: "none",
							fontWeight: "500",
						}}
					>
						← Back to Home
					</Link>
				</div>
			</div>
		</main>
	);
};

export default PrivacyPolicy;
